import { Card, CardContent, CardTitle, CardHeader, CardDescription } from "../ui/card"
import { Button } from "../ui/button";
import servicesData from "../../data/patient/health/health-service-card";
const HealthServiceCard = () => {
    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-10">
            {servicesData.map((item) => (
                <Card
                    key={item.id}
                    className="p-6 md:pt-10 md:pb-10 md:pr-8 md:pl-8
                            transition-all duration-300 ease-in-out hover:-translate-y-3 hover:shadow-2xl"
                >
                    <CardHeader className="flex p-0 flex-col items-center gap-4 md:gap-6">
                        <img
                            src={item.image}
                            alt={item.title}
                            className="h-12 w-12 md:h-14 md:w-14 object-contain"
                        />
                        <CardTitle className="text-blue-900 text-xl md:text-2xl font-semibold">
                            {item.title}
                        </CardTitle>
                    </CardHeader>

                    <CardContent className="text-gray-600 mt-4 pl-0 pr-0 text-sm text-center">
                        <CardDescription>{item.description}</CardDescription>
                    </CardContent>

                    <div className="flex justify-center">
                        <Button
                            variant="patient.secondary"
                            size="sm"
                            className="rounded-full">
                            {item.buttonText}
                        </Button>
                    </div>
                </Card>
            ))}
        </div>
    );
};

export default HealthServiceCard;
